/**
 * Core's room section rows (the room's level, ceiling height, width and
 * length, and, where it can be edited, its quarter-turn rotate) as ONE
 * section with one presentation, whether nothing is selected (the panel's
 * default view) or the whole room is (a click on the bare floor). Inputs
 * commit on blur/Enter, and a read-only panel shows the same rows as text; the
 * `data-set` and `data-act` keys are the stable E2E anchors.
 */

import { roomLevel } from '@kaiizen/kai-floor-plan';
import { roomSectionRows, rotateRoom, selectableLevels, setRoomLevel, useFloorPlanEditorState } from '@kaiizen/kai-floor-plan-editor-core';
import { SECTION_STYLE } from './chrome';
import { CommitLengthField } from './fields';
import { LevelField } from './LevelField';
import { RotateRoomRow } from './RotateRoomRow';

/** The room fields, for a host that supplies its own section chrome (the selection inspector). */
export function RoomFields(): React.JSX.Element {
  const floorPlanEditorState = useFloorPlanEditorState();
  const shape = floorPlanEditorState.st.shape;
  return (
    <>
      {roomSectionRows(shape, floorPlanEditorState.st.readOnly ?? false).map(row => {
        if (row.key === 'level') {
          return (
            <LevelField
              key='level'
              id='room-level'
              value={roomLevel(shape)}
              levels={selectableLevels([shape])}
              onChange={level => setRoomLevel(floorPlanEditorState, level)}
            />
          );
        }
        if (row.key === 'rotate') return <RotateRoomRow key='rotate' onRotate={quarterTurns => rotateRoom(floorPlanEditorState, quarterTurns)} />;
        return <CommitLengthField key={row.key} label={row.label} setKey={row.key} value={row.value} />;
      })}
    </>
  );
}

/** The fields in their own titled section: the nothing-selected default view. */
export function RoomSection(): React.JSX.Element {
  return (
    <div css={SECTION_STYLE}>
      <h2>Room</h2>
      <RoomFields />
    </div>
  );
}
